import { NextURL } from 'next/dist/server/web/next-url';

import { checkIpInRange } from './common';
import { blackListIPs, NOT_ALLOWED_COUNTRIES } from './conf';
import { Locale } from './languages';
import { CurrentIp } from '@/api/common';
import {
  AVAILABLE_LOCALES,
  DEFAULT_LOCALE,
  LANGUAGES,
} from '@/modules/localization';

export const determineLanguageByCountryCode = (userCountry: string) => {
  return LANGUAGES[userCountry]?.[0]?.locale || DEFAULT_LOCALE;
};

export const determineLocaleFromUrl = (pathname: NextURL['pathname']) => {
  return (
    AVAILABLE_LOCALES.find((locale) => locale === pathname.split('/')[1]) ||
    DEFAULT_LOCALE
  );
};

export const checkIP = checkIpInRange(blackListIPs);

export const isCountryNotAllowed = (
  countryCode: CurrentIp['countryCode'],
  ip: CurrentIp['ip']
) => {
  return NOT_ALLOWED_COUNTRIES.includes(countryCode) || checkIP(ip);
};

export const getCurrentLocale = (locale: string): Locale => {
  const isLocaleAvailable = Object.values(Locale).includes(locale as Locale);
  const newLocale = isLocaleAvailable ? locale : DEFAULT_LOCALE;

  return newLocale as Locale;
};
